import React from 'react'
import PropTypes from 'prop-types'
import {
  CheckIconWrapper,
  ErrorText,
  FieldWrapper,
  HeaderText,
  HiddenCheckbox,
  Label,
  QuestionText,
  QuestionWrapper,
  RadioCircle,
  RadioField,
  SelectionsWrapper,
  StyledCheckbox,
  StyledCheckIcon,
  StyledWarningIcon,
  StyledHr,
} from './component.styles'

const AddImplementationApproach = ({
  errors,
  handleChange,
  handleSubmit,
  modalData,
  touched,
  values,
}) => {
  const { header, choiceContent } = modalData
  return (
    <form onSubmit={handleSubmit}>
      <HeaderText>{header}</HeaderText>
      <QuestionWrapper>
        <QuestionText>{choiceContent[0].questionText}</QuestionText>
        <StyledHr />
        <SelectionsWrapper>
          <FieldWrapper>
            <RadioField
              checked={values.implementationType === 'Pilot'}
              id="Pilot"
              name="implementationType"
              type="radio"
              value="Pilot"
            />
            <RadioCircle htmlFor="Pilot" />
            <Label for="Pilot">{choiceContent[0].answerChoice1}</Label>
          </FieldWrapper>
          <FieldWrapper>
            <RadioField
              checked={values.implementationType === 'SchoolWide'}
              id="SchoolWide"
              name="implementationType"
              type="radio"
              value="SchoolWide"
            />
            <RadioCircle htmlFor="SchoolWide" />
            <Label for="SchoolWide">{choiceContent[0].answerChoice2}</Label>
          </FieldWrapper>
        </SelectionsWrapper>
        {touched.implementationType && errors.implementationType && (
          <ErrorText>
            <StyledWarningIcon />
            {errors.implementationType}
          </ErrorText>
        )}
      </QuestionWrapper>
      <QuestionWrapper>
        <QuestionText>{choiceContent[1].questionText}</QuestionText>
        <StyledHr />
        <SelectionsWrapper>
          <FieldWrapper>
            <HiddenCheckbox
              checked={values.teacherLed}
              id="teacherLed"
              name="teacherLed"
              onChange={e => handleChange('teacherLed', e.target.checked)}
              type="checkbox"
            />
            <StyledCheckbox htmlFor="teacherLed">
              <CheckIconWrapper>
                <StyledCheckIcon />
              </CheckIconWrapper>
            </StyledCheckbox>
            <Label for="teacherLed">{choiceContent[1].answerChoice1}</Label>
          </FieldWrapper>
          <FieldWrapper>
            <HiddenCheckbox
              checked={values.counselorLed}
              id="counselorLed"
              name="counselorLed"
              onChange={e => handleChange('counselorLed', e.target.checked)}
              type="checkbox"
            />
            <StyledCheckbox htmlFor="counselorLed">
              <CheckIconWrapper>
                <StyledCheckIcon />
              </CheckIconWrapper>
            </StyledCheckbox>
            <Label for="counselorLed">{choiceContent[1].answerChoice2}</Label>
          </FieldWrapper>
        </SelectionsWrapper>
        {(touched.counselorLed || touched.teacherLed) &&
          (errors.counselorLed || errors.teacherLed) && (
            <ErrorText>
              <StyledWarningIcon />
              {errors.counselorLed ? errors.counselorLed : errors.teacherLed}
            </ErrorText>
          )}
      </QuestionWrapper>
    </form>
  )
}

AddImplementationApproach.propTypes = {
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  modalData: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
}

export default AddImplementationApproach
